import { render, staticRenderFns } from "./AppTipText.vue?vue&type=template&id=973acc92&scoped=true&"
import script from "./AppTipText.vue?vue&type=script&lang=js&"
export * from "./AppTipText.vue?vue&type=script&lang=js&"
import style0 from "./AppTipText.vue?vue&type=style&index=0&id=973acc92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973acc92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('973acc92')) {
      api.createRecord('973acc92', component.options)
    } else {
      api.reload('973acc92', component.options)
    }
    module.hot.accept("./AppTipText.vue?vue&type=template&id=973acc92&scoped=true&", function () {
      api.rerender('973acc92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppTipText.vue"
export default component.exports